import { Controller, useForm } from 'react-hook-form';
import Drawer from '../../../../../components/Drawer';
import { FormElement } from '../../../Funds/components/Jurisdictions/style';
import { Form, Label } from './style';
import { Footer } from '../../style';
import { useEffect } from 'react';
import Button from '../../../../../components/Button';
import Breadcrumb from '../../../../../components/Breadcrumb';
import { Flex } from '@mantine/core';

const ArrowLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.80482 3.52861C8.06517 3.78896 8.06517 4.21107 7.80482 4.47141L4.94289 7.33334H12.6667C13.0349 7.33334 13.3334 7.63182 13.3334 8.00001C13.3334 8.3682 13.0349 8.66668 12.6667 8.66668H4.94289L7.80482 11.5286C8.06517 11.789 8.06517 12.2111 7.80482 12.4714C7.54447 12.7318 7.12236 12.7318 6.86201 12.4714L2.86201 8.47141C2.60166 8.21107 2.60166 7.78896 2.86201 7.52861L6.86201 3.52861C7.12236 3.26826 7.54447 3.26826 7.80482 3.52861Z"
      fill="#868E96"
    />
  </svg>
);

export const NewAIFDrawer = ({
  isOpen,
  onBack,
  onClose,
  onSubmit,
  hideAIFM,
  isLoading,
  defaultValues
}) => {
  const { control, reset, handleSubmit, watch } = useForm({
    defaultValues
  });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const funds = watch('funds')
    ?.split(/[\n,]+/)
    .filter(fund => fund);

  const links = [
    {
      name: 'Add New Project',
      onClick: onBack,
      style: {
        fontSize: '16px'
      }
    },
    {
      name: 'Add New Funds',
      style: {
        fontSize: '16px'
      }
    }
  ];

  if (hideAIFM) delete links[0];

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title={
        <Flex alignItems="center" gap={8}>
          {!hideAIFM && <ArrowLeftIcon />}
          <Breadcrumb links={links} />
        </Flex>
      }
      style={{
        maxWidth: 410,
        minWidth: 410
      }}
    >
      <Form onSubmit={handleSubmit(() => onSubmit(funds))}>
        <FormElement>
          <Label>Fund Names</Label>
          <Controller
            name="funds"
            control={control}
            render={({ field: { value, onChange } }) => (
              <textarea
                size="xs"
                value={value}
                onChange={onChange}
                rows={3}
                placeholder="Add one or multiple Funds, separated by commas"
              />
            )}
          />
        </FormElement>

        <Footer>
          <Button size="sm" disabled={!funds || !funds?.length || isLoading} type="submit">
            {isLoading ? 'Saving...' : 'Save'} {funds && funds.length && `(${funds.length || 0})`}
          </Button>
        </Footer>
      </Form>
    </Drawer>
  );
};
